import { useTranslation } from "react-i18next";
import { Button } from "@components/Button";
import { Modal } from "@components/Modal/Modal";
import { useModal } from "@hooks/useModal";
import { type IUseModalProps } from "@store/modal/modal";

interface IProjectDataConfirmModalProps extends IUseModalProps {
  onSubmit: () => void;
  onCancel: () => void;
}

export const ProjectDataConfirmModal: React.FC<
  IProjectDataConfirmModalProps
> = ({ onSubmit, onCancel, ...modalProps }) => {
  const { t } = useTranslation();
  const modal = useModal(modalProps);

  return (
    <Modal
      modal={modal}
      title={t("settings.house.projectDataRenewal.confirm.title")}
      actionButtons={
        <>
          <Button
            variant="secondary"
            onClick={() => {
              onCancel();
              modal.close();
            }}
            className="w-full"
          >
            {t("settings.house.projectDataRenewal.confirm.buttons.cancel")}
          </Button>
          <Button
            onClick={() => {
              onSubmit();
              modal.close();
            }}
            className="w-full"
          >
            {t("settings.house.projectDataRenewal.confirm.buttons.submit")}
          </Button>
        </>
      }
    />
  );
};
